import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { COMPANY, CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
// @ts-expect-error untyped
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getObjectTypeId } from '../../../utils/crmObjectHelpers';
import { getLabel, getObjectRecord } from './utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociationAvatars = ({
  associatedObjects
}) => {
  const firstObjectRecord = getIn([0, 'objectRecord'], associatedObjects);
  const firstObjectTypeId = getObjectTypeId(firstObjectRecord);
  const isContactOrCompanyObjectType = firstObjectTypeId === ObjectTypesToIds[CONTACT] || firstObjectTypeId === ObjectTypesToIds[COMPANY];
  if (!isContactOrCompanyObjectType) {
    return null;
  }
  const lookupProps = associatedObjects.toArray().map(objectData => {
    const displayName = getLabel(objectData);
    const objectRecord = getObjectRecord(objectData);
    const objectTypeId = getObjectTypeId(objectRecord);
    const isCompanyObject = objectTypeId === ObjectTypesToIds[COMPANY];
    const avatarType = isCompanyObject ? 'company' : 'contact';

    // These should be defined if the object is a contact
    const vid = get('vid', objectRecord);
    const email = getProperty(objectRecord, 'email');
    // these should be defined if the object is a company
    const companyId = get('companyId', objectRecord);
    const domain = getProperty(objectRecord, 'domain');
    if (isCompanyObject && (companyId || domain)) {
      return {
        companyId,
        domain,
        displayName
      };
    } else if (!isCompanyObject && (vid || email)) {
      // Don't include the displayName here. Users find it helpful to hover over a contact
      // in order to see their email address
      return {
        vid,
        email
      };
    } else {
      return {
        type: avatarType,
        displayName
      };
    }
  });

  // if there's only 1 then there's no need to use the "Group" functionality which makes it slightly smaller
  if (lookupProps.length === 1) {
    return /*#__PURE__*/_jsx(View, {
      marginInlineEnd: "100",
      children: /*#__PURE__*/_jsx(UIAvatar, Object.assign({}, lookupProps[0], {
        size: "xs"
      }))
    });
  }
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "100",
    children: /*#__PURE__*/_jsx(UIAvatar, {
      lookup: lookupProps,
      size: "xs"
    })
  });
};
export default AssociationAvatars;